/*
tslint:disable:import-spacing no-inferrable-types
variable-name align no-trailing-whitespace component-class-suffix
no-string-literal component-selector
*/

import 'ag-grid-enterprise';
import {BatchCell} from "@/models/batch/batch.cell";
import {ICellRenderer, ICellRendererParams} from "ag-grid-community";


/**
 *
 * @class BatchEditCellRenderer
 *
 * @brief cell rendering a batch cell (edit mode)
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      February 2022
 *
 */
export class BatchEditCellRenderer implements ICellRenderer {

  /** agGrid DOM element for display */
  public gui: HTMLElement;

  /** current value of the cell */
  public value: BatchCell = null;

  /** first time creation of the rendered cell. */
  public init(params: ICellRendererParams): void {

    const style = `color: rgba(245, 245, 245, 0.64);`;

    this.gui           = document.createElement('div');
    this.gui.innerHTML = `<span style="${style}"></span>`;

    /* render! */

    this.refresh(params);
  }

  /** return the currently rendered DOM */
  public getGui(): HTMLElement {

    return this.gui;
  }

  /** update the rendered DOM */
  public refresh(params: ICellRendererParams): boolean {

    const style = `color: rgba(245, 245, 245, 0.64);`;

    this.value = params?.value as BatchCell;

    if (!this.value) {

      this.gui.innerHTML = `<span style="${style}"></span>`;
      return ;
    }

    let label: string = `${this.value.column}, ${this.value.row}`;

    /* if its enabled or disabled, we show the cell with different colors */

    if (this.value.enabled) {

      this.gui.style.backgroundColor = '#515151';
      this.gui.style.color           = '#BBBBBB';
      this.gui.style.fontWeight      = 'bold';
    }





    /* render */

    this.gui.innerHTML = `<span style="${style}">${label}</span>`;

    return true;
  }

  /** destructor for rendered DOM */
  public destroy() {

  }

}
